export default class DeleteCallRecording {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, conversationItemId }) {
    this.context.gateways.voiceRecording.deleteCallRecording(customerId, conversationItemId);
  }
}
